import { render, staticRenderFns } from "./RadioList.vue?vue&type=template&id=bb2eccec&scoped=true&"
import script from "./RadioList.vue?vue&type=script&lang=js&"
export * from "./RadioList.vue?vue&type=script&lang=js&"
import style0 from "./RadioList.vue?vue&type=style&index=0&id=bb2eccec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2eccec",
  null
  
)

export default component.exports